"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalAttributesSchema = void 0;
exports.resolveSignalAttributes = resolveSignalAttributes;
const zod_1 = require("zod");
const SignalTypeDeprecated_1 = require("./SignalTypeDeprecated");
exports.SignalAttributesSchema = zod_1.z.object({
    power: zod_1.z.boolean().optional(),
    ground: zod_1.z.boolean().optional(),
    analog: zod_1.z.boolean().optional(),
    digital: zod_1.z.boolean().optional(),
    exposedPad: zod_1.z.boolean().optional(),
    noConnect: zod_1.z.boolean().optional(),
    activeLow: zod_1.z.boolean().optional(),
});
function resolveSignalAttributes(signal) {
    return {
        power: (signal.attributes?.power ?? signal.signalType === SignalTypeDeprecated_1.SignalType.Power) || false,
        ground: (signal.attributes?.ground ?? signal.signalType === SignalTypeDeprecated_1.SignalType.Ground) || false,
        analog: (signal.attributes?.analog ?? signal.analog ?? signal.signalType === SignalTypeDeprecated_1.SignalType.Analog) || false,
        digital: (signal.attributes?.digital ?? signal.signalType === SignalTypeDeprecated_1.SignalType.Digital) || false,
        noConnect: (signal.attributes?.noConnect ?? signal.signalType === SignalTypeDeprecated_1.SignalType.NoConnect) || false,
        exposedPad: signal.attributes?.exposedPad ?? false,
        activeLow: signal.attributes?.activeLow ?? false,
    };
}
//# sourceMappingURL=SignalAttributes.js.map